
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"14","height":"15","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M11.028 6.713H7.417V3.102a.602.602 0 00-1.204 0v3.611H2.602a.602.602 0 000 1.204h3.611v3.61a.602.602 0 001.204 0v-3.61h3.61a.602.602 0 000-1.204z","fill":"#161619"}})])
          )
        }
      }
    